import { FixtureInstance } from '@/api/internal';

export class GeosearchAPI extends FixtureInstance {}
